import { FieldValues, RegisterOptions } from 'react-hook-form';

import { t } from '@gem/modules/i18n';

import { storage } from 'APP/packages/storage';

export function getUniqueAliasValidation<TFieldValues extends FieldValues = FieldValues>(
  email: string
): RegisterOptions<TFieldValues> {
  return {
    validate: {
      unique: (value: string): string | boolean => {
        if (!value) return true;

        const isDuplicate = storage.discoverDestinations
          .get(email)
          .some((destination) => destination.alias.toLowerCase() === value.toLowerCase());

        return isDuplicate ? t('auth_company_server_alias_error') : true;
      },
    },
  };
}
